<template>
  <div class="body-width divcss5">
    <div>
          <div class="div-row div-bottom news-Medium-24">
        海大智龙在线实操训练平台注册登录指南
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      
        <div class="div-text-left news-Regular-14b6">
            <span>2020-04-01</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
            <div class="div-line  divcss5">
      
      </div>
            <div class="div-row div-bottom10">
          <p class="indentation">
         1. 登录海大智龙官网：www.zlonmarine.com
        </p>
         <p class="indentation">
         2. 点击主页“产品中心“中的”在线产品试用“菜单
        </p>
      </div>
         <div class="div-row div-bottom10 ">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news8/01.jpg" />
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
          <p class="indentation">
        3. 点击海大智龙在线实操训练平台页面右上角的“注册“（”Register”）按钮
        </p>
         <p class="indentation">
         4. 在弹出的注册页面中注册后即可登录运行平台的实训软件（包括4种船型配载软件、雷达模拟软件、ECDIS模拟软件、GMDSS模拟软件，避碰练习软件等）
        </p>
      </div>
<div class="div-row div-bottom10 ">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news8/02.jpg" />
          </div>
        </div>
      </div>

<div class="div-row div-bottom10  div-top30">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news8/03.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10  div-top30">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news8/04.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10  div-top30">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news8/05.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10  ">
        <div class="  div-top box2">
              <div class="div-margin news-Medium-18">
                <B>散货船、液货船、集装箱船、多用途船配载软件</B>
              </div>
          <div class="div-margin " >
            <img src="../../../assets/images/news8/06.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10  ">
        <div class=" div-margin">
           <div class="row ">
          <div class="col-lg-5 news-Medium-18" >
        <B> JRC-9100S 雷达模拟 </B>
          </div>
           <div class=" col-lg-7 news-Medium-18" >
       <B> ECDIS软件</B>
          </div>
              </div>
           <div class="div-margin " >
                    <img src="../../../assets/images/news8/07.jpg" />
              <img src="../../../assets/images/news8/08.jpg" />
          </div>
        </div>
      </div>
     <div class="div-row div-bottom10  ">
        <div class="  div-top box2">
              <div class="div-margin news-Medium-18">
                <B> GMDSS软件</B>
              </div>
          <div class="div-margin " >
            <img src="../../../assets/images/news8/09.jpg" />
          </div>
        </div>
      </div>

  <div class="div-row div-bottom10  ">
        <div class=" div-margin">
           <div class="row ">
          <div class="col-lg-6 news-Medium-18" >
        <B> 操纵避碰虚拟仿真在线训练软件 </B>
          </div>
           <div class=" col-lg-6 news-Medium-18" >
       <B> 操纵避碰模拟考试软件及APP</B>
          </div>
              </div>
           <div class="div-margin " >
                    <img src="../../../assets/images/news8/10.jpg" />
              <img src="../../../assets/images/news8/11.jpg" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }


  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 10px;
  }
.div-text-left{
  text-align: left;
  padding-left: 20px;
  margin-bottom: 20px;

}
.div-padding-left{
  padding-left: 36px;
}
.div-top30{
  margin-top: 30px;
}
.div-top0{
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news8.vue